import { useContext } from 'react';

import Close from '@lokalise/ui/icons/Close';

import IconButton from '../../IconButton';
import ModalContext from '../context';

const ModalCloseButton = () => {
    const { onClose } = useContext(ModalContext);

    return (
        <IconButton ariaLabel="Close dialog" onClick={onClose}>
            <Close />
        </IconButton>
    );
};

export default ModalCloseButton;
